import { Loader } from "@mantine/core";
import React from "react";

const CLoader = () => {
  return (
    <div className=" h-screen w-screen flex items-center justify-center">
      <div>
        <Loader size={100} />
      </div>
    </div>
  );
};

export default CLoader;
